import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input
} from '@angular/core';

/** Error bubble. Renders for transport errors and SDK `error` signal events. */
@Component({
  selector: 'portal-block-error',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './block-error.component.html'
})
export class PortalBlockErrorComponent {
  @HostBinding('class') readonly hostClass = 'contents';
  readonly content = input.required<string>();
}
